<template>
	<div class="tw-pb-10">
		<div class="tw-flex tw--mx-2">
			<div
				class="tw-px-2"
				:class="{
					'tw-w-4/6' : selectedJobPosition.id,
					'tw-w-full' : !selectedJobPosition.id,
				}"
			>
				<card class="tw-mb-6">
					<card-header>
						<job-hierarchy-header />
					</card-header>
					<div class="tw-py-6"  style="min-height: 300px;">
						<job-hierarchy-form
							:hierarchy-assignation="hierarchyAssignation"
							:selected-job-position="selectedJobPosition"
							:selected-job-position-level="selectedJobPositionLevel"
							@selectedJobPosition="onSelectedJobPosition"
						/>
					</div>
				</card>
			</div>
			<div class="tw-w-2/6 tw-px-2" v-if="selectedJobPosition.id">
				<hierarchy-children-list-card
					:selected-job-position="selectedJobPosition"
					:hierarchy-assignation="hierarchyAssignation"
					@closeClick="onCloseClicked"
				/>
			</div>
		</div>
		<div class="tw-text-center">
			<v-btn
				color="primary"
				class="custom-button tw-px-8"
				:disabled="!allHaveParent"
				@click="generateOrganizationChart"
			>
				Generar Organigrama
			</v-btn>
		</div>
	</div>
</template>

<script>
import Card from '@/modules/shared/components/ui/Card/Card';
import CardHeader from '@/modules/shared/components/ui/Card/CardHeader';
import JobHierarchyHeader from '@/modules/job-evaluation/components/supplies/guideline-model/hierarchy/hierarchy-assignation/job-hierarchy-header';
import JobHierarchyForm from '@/modules/job-evaluation/components/supplies/guideline-model/hierarchy/job-hierarchy-form';
import { mapState } from 'vuex';
import { pathOr, pipe, pluck, drop, all, isNil, prop } from 'ramda';
import HierarchyChildrenListCard
	from '@/modules/job-evaluation/components/supplies/guideline-model/hierarchy/hierarchy-children/hierarchy-children-list-card';

export default {
	name: 'page-supply-guideline-model-hierarchy',
	components: { HierarchyChildrenListCard, JobHierarchyForm, JobHierarchyHeader, CardHeader, Card },
	beforeMount() {
		this.$store.dispatch('jobEvaluation/getGuidelineModelStatus');
	},
	data() {
		return {
			selectedJobPosition: {},
			selectedJobPositionLevel: -1,
		};
	},
	computed: {
		...mapState('jobEvaluation', {
			hierarchyAssignation: pathOr([], ['supplies', 'guidelineModel', 'hierarchyAssignation']),
		}),
		allHaveParent() {
			return pipe(
				pluck('jobPositions'),
				drop(2),
				all(jobPositions => all(job => !isNil(prop('fatherId', job)), jobPositions)),
			)(this.hierarchyAssignation);
		},
	},
	methods: {
		onSelectedJobPosition({ jobPosition, level }) {
			this.selectedJobPosition = jobPosition;
			this.selectedJobPositionLevel = level;
		},
		onCloseClicked() {
			this.selectedJobPosition = {};
			this.selectedJobPositionLevel = -1;
		},
		generateOrganizationChart() {
			this.$store.dispatch('jobEvaluation/generateOrganizationChart')
				.then(() => { this.goTo('job-supply-organization-chart'); })
				.catch(e => console.error(e));
		},
	},
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/modules/job-evaluation/pages/supplies/guideline-model/page-supply-guideline-model-hierarchy.vue